module.exports = __webpack_public_path__ + "static/media/device_privatization.a539f3f3.md";